import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import theme from 'theme'

export const ResetWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  align-items: center;
  position: sticky;
  bottom: 0;
  background: ${theme.colors.legacyBackgroundDark};

  .reset-button {
    border-radius: ${theme.attributes.borderRadius.large};
    cursor: pointer;
    color: ${theme.colors.cta};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    text-transform: none;
    width: 100% !important;
    height: 40px;

    &:hover {
      background: ${theme.colors.legacyAlpha1};
    }

    &.Mui-disabled {
      background: transparent !important;
      opacity: 1;
      color: ${theme.colors.btnSecondaryDisabledText};
      text-align: center;
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.thin};
      line-height: normal;
    }
  }
`
